import IconButton from "@mui/material/IconButton";
import FunnelIcon from "@mui/icons-material/FilterAlt";
import React from "react";
export default function FilterSection({ children, sortControl }) {
  const [open, setOpen] = React.useState(false);
  return (
    <div>
      <div className="filter-container">
        <IconButton
          type="button"
          className="filter-toggle"
          onClick={() => setOpen((o) => !o)}
          aria-label={open ? "Hide filters" : "Show filters"}
          aria-expanded={open}
        >
          <FunnelIcon className="icon" />
        </IconButton>
        {sortControl}
      </div>
      {open && <div className="filter-panel">{children}</div>}
    </div>
  );
}
